module.exports = __webpack_public_path__ + "img/dog-head.7982c2a9.gif";